export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/a92d826d80900dda6092d3b109ffaee1.svg";